import { render } from "./lang.vue?vue&type=template&id=b28261ee&scoped=true"
import script from "./lang.vue?vue&type=script&lang=js"
export * from "./lang.vue?vue&type=script&lang=js"

import "./lang.vue?vue&type=style&index=0&id=b28261ee&lang=less&scoped=true"

import exportComponent from "E:\\A-OnlineServiceCenter\\stableBuilds\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28261ee"]])

export default __exports__